import { useCallback } from 'react';

import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { openReportReviewModal } from '@/redux/modules/modal';
import { isSubmitted, setBidderReviewStatus } from '@/redux/modules/reviewStatus';

import { Helpful } from './Helpful';
import Report from './Report';

export type ReviewFeedbackBarProps = {
    helpfulCount: number;
    reviewId: number;
    statuses: string[];
};

export const ReviewFeedbackBar = (props: ReviewFeedbackBarProps) => {
    const { helpfulCount, reviewId, statuses } = props;
    const dispatch = useAppDispatch();
    const submitted = useAppSelector((state) => isSubmitted(state));

    const helpfulClick = useCallback(() => {
        dispatch(
            setBidderReviewStatus({
                active: !statuses.includes('helpful'),
                reviewId: reviewId,
                reviewStatus: 'helpful',
            })
        );
    }, [dispatch, reviewId, statuses]);

    const reportClickHandler = () => {
        dispatch(openReportReviewModal(reviewId));
    };

    const isHelpful = statuses.includes('helpful');
    const isReported = statuses.includes('reported');

    const reportClick = isReported ? null : reportClickHandler;

    return (
        <div className="mt-sm flex min-h-[40px] items-center">
            <ShouldLogInContainer
                requireLogin
                runFunction={helpfulClick}
            >
                <Helpful
                    active={isHelpful}
                    className="flex items-center pr-sm"
                    count={helpfulCount}
                    key="helpful"
                    onClick={helpfulClick}
                    submitted={submitted}
                />
            </ShouldLogInContainer>
            <ShouldLogInContainer
                requireLogin
                runFunction={reportClick}
            >
                <Report
                    active={isReported}
                    className="ml-md"
                    key="report"
                    onClick={reportClick}
                />
            </ShouldLogInContainer>
        </div>
    );
};
